<div class="status-message-container" [class.success]="isSuccess" [class.error]="!isSuccess">
  <img
    [src]="
      isSuccess
        ? './../../../assets/doc-signed1.png'
        : './../../../assets/error.png'
    "
  />
  @if(heading) {
  <h1 class="status-message-heading">
    {{ heading }} {{ isSuccess ? "😊" : "😔" }}
  </h1>
  }
  <span class="status-message">{{ message }}</span>
</div>
